import { Helmet } from 'react-helmet-async';
import { useCallback, useEffect, useRef, useState } from 'react';
// @mui
import { Button, CircularProgress, Container, Stack, Typography } from '@mui/material';
// components
import { ProductList } from '../sections/@dashboard/products';
// mock
import AddButton from 'src/components/Button.js/AddBotton';
import { useParams } from 'react-router-dom';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import Loader from 'src/components/loader/loader';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import GroupDeviceModal from 'src/components/modal/GroupDevice';
import Iconify from 'src/components/iconify/Iconify';
import * as XLSX from 'xlsx';
import CreateGroupExcelModal from 'src/components/modal/CreateGroupExcelModal';
import EmtyData from 'src/components/emty-data';

// ----------------------------------------------------------------------

export default function GroupDevice() {
    const [visible, setVisible] = useState(false);
    const [visibleDel, setVisibleDel] = useState(false);
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const { t } = useTranslation();
    const params = useParams();
    const delFlags = useRef(false);
    const isEdit = useRef(false);
    const [data, setData] = useState({});
    const [deleleFlags, setDeleleFlags] = useState(false);
    const success = useRef(false);
    const getRef = useRef(false);
    const [checkDataExcel, setCheckDataExcel] = useState(false);
    const fileInputRef = useRef(null);
    const [dataExcel, setDataExcel] = useState([]);
    const [visibleExcel, setVisibleExcel] = useState(false);
    const [screenPermissions, setScreenPermissions] = useState({});

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, [success.current]);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [+params.idPermission, 'all'];
        sendRequest(serviceList.getAllgroup_devicesUser, InVal, getDataResult, true, timeOutFunct, 40000);
    }, [success.current]);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            // console.log('group permission', message.proc_data.rows[1].o_1[0][0])
            setTableData(message.proc_data.rows[0].o_1);
            setScreenPermissions(message.proc_data.rows[1].o_1[0][0]);
            const arr = message.proc_data.rows[0].o_1;
            // console.log('🚀 ~ file: GroupDevice.js:66 ~ getDataResult ~ arr:', arr);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const handleDelete = () => {
        if (!data.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [+params.idPermission, data.id];
        sendRequest(serviceList.deletegroup_devices, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDel(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleDel(false);
            getData();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const handleFileUpload = (event) => {
        setDataExcel([]);
        deleteTableExcel();
        if (event.target.files.length > 0) {
            setCheckDataExcel(true);
            const file = fileInputRef.current.files[0];
            try {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    if (workbook.SheetNames.length > 0) {
                        // Lấy dữ liệu từ sheet đầu tiên
                        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                        // console.log(jsonData);
                        if (jsonData?.length > 0) {
                            jsonData.map((item, index) => {
                                if (index !== 0)
                                    if (item.length >= 3) {
                                        importExcel(item);
                                    } else {
                                        setTimeout(() => {
                                            toast.error(`${t('row_data')}${index} ${t('invalid')}`);
                                        }, index * 100 + 1000);
                                    }
                                if (index + 1 === jsonData.length) {
                                    // setTotalDataExcel(jsonData.length);
                                    setVisibleExcel(true);
                                }
                            });
                        } else {
                            toast.error(t('data_file_err'));
                        }
                    } else {
                        toast.error(t('file_excel_err'));
                    }
                    // In ra dữ liệu từ file Excel
                };

                reader.readAsArrayBuffer(file);
            } catch (error) {}
            setCheckDataExcel(false);
        } else {
        }
        fileInputRef.current.value = '';
    };

    // Đưa dữ liệu lên server
    const importExcel = (data) => {
        if (!data || data.length < 3) return;
        sendRequest(
            serviceList.uploadExcelGroups,
            [data[0], data[1], `${data[2]}`],
            importExcelResult,
            true,
            timeOutImport,
            40000
        );
    };
    const importExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows;
            const newArr = dataExcel;
            newArr.push(data);
            setDataExcel(JSON.parse(JSON.stringify(newArr)));
        }
    };
    const timeOutImport = (reqInfo) => {};

    const deleteTableExcel = () => {
        const InVal = [];
        sendRequest(serviceList.delExcelGroups, InVal, deleteExcelResult, true, timeOutDeleteTabbelExcel, 40000);
    };

    const deleteExcelResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        }
    };
    const timeOutDeleteTabbelExcel = (reqInfo) => {};

    return (
        <>
            <Helmet>
                <title> {t('group_devices')}</title>
            </Helmet>
            <CreateGroupExcelModal
                visible={visibleExcel}
                setDataExcel={setDataExcel}
                setVisible={setVisibleExcel}
                fuctGet={getData}
                dataExcel={dataExcel}
            />
            <Container>
                <Loader loading={getFlags} />
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1} flexWrap={'wrap'}>
                    <Typography variant="h4" gutterBottom>
                        {t('group_devices')}
                    </Typography>{' '}
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0} gap={1}>
                        <label htmlFor="import" style={{ cursor: 'pointer' }}>
                            <Button
                                variant="contained"
                                disabled={checkDataExcel}
                                startIcon={<Iconify icon="mingcute:file-import-line" />}
                            >
                                <label htmlFor="import"> {t('import') + ' excel'}</label>{' '}
                                {checkDataExcel && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                            color: 'red',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            marginTop: '-12px',
                                            marginLeft: '-12px',
                                        }}
                                    />
                                )}
                            </Button>
                        </label>{' '}
                        <input
                            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            type="file"
                            hidden
                            ref={fileInputRef}
                            onChange={handleFileUpload}
                            id="import"
                            name="import"
                        />
                        <Button variant="contained" startIcon={<Iconify icon="mingcute:file-download-line" />}>
                            <a
                                style={{ textDecoration: 'none', color: 'white' }}
                                target="_blank"
                                download
                                to={`${glb_sv.urlDownloadFileExcel('ExampleGroupDevice.xlsx')}`}
                                href={`${glb_sv.urlDownloadFileExcel('ExampleGroupDevice.xlsx')}`}
                            >
                                {t('download_file')}
                            </a>
                        </Button>
                    </Stack>
                </Stack>
                <Breadcrumb paths={[{ label: t('group_devices'), url: '#', navigate: false }]} />
                <GroupDeviceModal
                    isEdit={isEdit.current}
                    idPermission={params.idPermission}
                    visible={visible}
                    loading={deleleFlags}
                    dataUpdate={data}
                    fuctGet={getData}
                    setVisible={setVisible}
                />
                <ConfirmModal visible={visibleDel} setVisible={setVisibleDel} handleDelete={handleDelete} />
                {tableData.length > 0 ? (
                    <ProductList
                        products={tableData}
                        setData={setData}
                        isGroup
                        action
                        functEdit={() => {
                            isEdit.current = true;
                            setVisible(true);
                        }}
                        functDelete={() => setVisibleDel(true)}
                        screenPermissions={screenPermissions}
                    />
                ) : (
                    <EmtyData></EmtyData>
                )}
                <AddButton
                    onClick={() => {
                        isEdit.current = false;
                        setVisible(true);
                        setData({});
                    }}
                />
            </Container>
        </>
    );
}
